import { render, staticRenderFns } from "./EmbeddedInput.vue?vue&type=template&id=1052e398&"
import script from "./EmbeddedInput.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports